import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  delete(event) {
    event.preventDefault()
    if (!confirm("Are you sure you want to delete this file?")) return

    const token = document.head.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/html"
      }
    }).then(response => {
      if (response.redirected) {
        window.location.href = response.url
      } else if (response.ok) {
        window.location.reload()
      }
    })
  }
}
